import StarIcon from "@mui/icons-material/Star";
import { Box } from "@mui/material";
import { Text } from "@clipboard-health/ui-react";
import { A_TEAM_COLOR } from "@src/appV2/Professionals/MyProfessionals/constants";

export function StarProfessionalTag() {
  return (
    <Box
      sx={{
        borderRadius: 0.5,
        paddingY: 0,
        paddingX: 0.75,
        width: "fit-content",
        display: "flex",
        alignItems: "center",
        backgroundColor: `${A_TEAM_COLOR}`,
        color: (theme) => theme.palette.common.white,
      }}
    >
      <StarIcon sx={{ fontSize: (theme) => theme.typography.pxToRem(12), marginRight: 0.5 }} />
      <Text variant="caption" color="inherit">
        Starred
      </Text>
    </Box>
  );
}
